import React from 'react';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';
import classnames from 'classnames';
import { AvailabilityBusiness } from '@business/newCreateRequest/stepsItems/availability';
import { Button } from 'oned';
import { FlexibleType } from '@common/enums/availability';
var FlexibleIndex = inject(AvailabilityBusiness)(observer(function (props) {
    var availabilityStep = props.availabilityStep, availabilityType = props.availabilityType, flexibleType = props.flexibleType, setAvailabilityParams = props.setAvailabilityParams;
    var changeFlexibleType = function (type) {
        switch (type) {
            case FlexibleType.NotAvailable:
                if (flexibleType === FlexibleType.NotAvailable) {
                    setAvailabilityParams('flexibleType', null);
                }
                else {
                    setAvailabilityParams('flexibleType', FlexibleType.NotAvailable);
                }
                break;
            case FlexibleType.AllTimeIsGood:
                if (flexibleType === FlexibleType.AllTimeIsGood) {
                    setAvailabilityParams('flexibleType', null);
                }
                else {
                    setAvailabilityParams('flexibleType', FlexibleType.AllTimeIsGood);
                }
                break;
        }
    };
    return React.createElement(React.Fragment, null,
        React.createElement("h2", null,
            React.createElement("b", { className: 'title' }, "Flexible Availability")),
        React.createElement("div", { className: 'pt-0 ft-16' }, "Do you need to add specific times that you are not available?"),
        React.createElement("div", { className: 'row' },
            React.createElement("div", { className: 'col-md-4 col-xs-12' },
                React.createElement(Button, { type: 'secondary', className: classnames('w-100 my-2 dsm-btn-secondary dsm-btn sc-btn f14', flexibleType === FlexibleType.NotAvailable && 'active'), onClick: function () { return changeFlexibleType(FlexibleType.NotAvailable); } }, "Yes, add times I\u2019m not available"),
                React.createElement("div", { className: 'pt-1 f14' }, "We will share these dates and times with the specialist.")),
            React.createElement("div", { className: 'col-md-4 col-xs-12' },
                React.createElement(Button, { type: 'secondary', className: classnames('w-100 my-2 dsm-btn-secondary dsm-btn sc-btn f14', flexibleType === FlexibleType.AllTimeIsGood && 'active'), onClick: function () { return changeFlexibleType(FlexibleType.AllTimeIsGood); } }, "No, any time is good with me"),
                React.createElement("div", { className: 'pt-1 f14' }, "If you choose this option, the specialist will schedule at the earliest time that works for them."))));
}));
export default FlexibleIndex;
